import { Resource } from 'constants/resources';

import {
  ReferenceArrayInput as RaReferenceArrayInput,
  ReferenceArrayInputProps as RaReferenceArrayInputProps,
} from 'react-admin';

export type ReferenceArrayInputProps = RaReferenceArrayInputProps & {
  disableReferenceFilter?: boolean;
  resource?: Resource;
};

export const ReferenceArrayInput: React.FC<ReferenceArrayInputProps> = ({
  disableReferenceFilter,
  filter,
  ...props
}) => {
  const finalFilter = disableReferenceFilter ? filter : { groups: ['reference'], ...filter };

  return <RaReferenceArrayInput {...props} filter={finalFilter} />;
};
